// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","horScrollFixer":"qPOxpHk0","mobile":"mobile","popmechanic-mobile":"popmechanic-mobile","responsive-wrapper":"responsive-wrapper"};